import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import base64jpg from '@/projects/cbnk/assets/files/base64jpg.txt?raw';
import base64txt from '@/projects/cbnk/assets/files/base64txt.txt?raw';
import base64pdf from '@/projects/cbnk/assets/files/base64pdf.txt?raw';
import base64xlsx from '@/projects/cbnk/assets/files/base64xlsx.txt?raw';
import base64docx from '@/projects/cbnk/assets/files/base64docx.txt?raw';
import base64zip from '@/projects/cbnk/assets/files/base64zip.txt?raw';
faker.seed(1);

export default Factory.extend({
	documentTypeId: () => faker.helpers.arrayElement(['Personal', 'Contract']),
	documentSubtypeId: () => faker.number.int({ min: 1, max: 2 }).toString(),
	subtypeDescription: () =>
		faker.helpers.arrayElement([
			'Declaración Residencia Fiscal',
			'Contrato de Servicios',
			'Identificación del Cliente',
			'Comprobante de Domicilio',
		]),
	description: () =>
		faker.lorem.sentence({
			min: 2,
			max: 8,
		}),
	productId: () =>
		faker.helpers.maybe(() => faker.number.int({ min: 100000, max: 999999 }).toString()),
	date: () => faker.date.recent({ days: 180 }).toISOString(),
	format: () => faker.helpers.arrayElement(['jpg']),
	state: () => faker.number.int({ min: 1, max: 8 }).toString(),
	manager: () => faker.helpers.maybe(() => faker.person.lastName().toUpperCase()),
	origin: () => faker.helpers.arrayElement(['USER', 'ENTITY']),
	displayName: () =>
		`${faker.person.firstName()} ${faker.person.lastName()} ${faker.person.lastName()}`,
	documentId: () => faker.helpers.arrayElement(['A01', 'A02', 'A03', 'A04']),
	afterCreate(doc) {
		doc.update({
			subdescription: doc.subtypeDescription,
			coreProductId: doc.productId,
			documentType: doc.documentTypeId,
		});
	},

	BC: trait({
		afterCreate(doc) {
			doc.update({
				displayName: `BC ${doc.displayName}`,
			});
		},
	}),
	FA: trait({
		afterCreate(doc) {
			doc.update({
				displayName: `FA ${doc.displayName}`,
			});
		},
	}),
	detail: trait({
		afterCreate(doc) {
			doc.update({
				documentType: doc.documentTypeId,
				documentSubtype: doc.documentSubtypeId,
				format: doc.format,
				file: doc.file,
			});
		},
	}),

	jpg: trait({
		format: 'jpg',
		file: base64jpg,
		afterCreate(doc) {
			doc.update({
				displayName: `jpg ${doc.displayName}`,
			});
		},
	}),

	txt: trait({
		format: 'txt',
		file: base64txt,
		afterCreate(doc) {
			doc.update({
				displayName: `txt ${doc.displayName}`,
			});
		},
	}),
	pdf: trait({
		format: 'pdf',
		file: base64pdf,
		afterCreate(doc) {
			doc.update({
				displayName: `pdf ${doc.displayName}`,
			});
		},
	}),
	xlsx: trait({
		format: 'xlsx',
		file: base64xlsx,
		afterCreate(doc) {
			doc.update({
				displayName: `xlsx ${doc.displayName}`,
			});
		},
	}),

	docx: trait({
		format: 'docx',
		file: base64docx,
		afterCreate(doc) {
			doc.update({
				displayName: `docx ${doc.displayName}`,
			});
		},
	}),
	zip: trait({
		format: 'zip',
		file: base64zip,
		afterCreate(doc) {
			doc.update({
				displayName: `zip ${doc.displayName}`,
			});
		},
	}),
});
